<script>
export default {
    data() {
        return {
            thumbnailContainerId: 'youtube-embed-thumbnail',
            thumbnailContainerElement: null,
            isThumbnailLoad: false
        }
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        thumbnail: {
            type: String,
            required: false,
            default: null
        }
    },
    mounted() {
        this.thumbnailContainerElement = document.getElementById(this.thumbnailContainerId);
    },
    computed: {
        getThumbnailHeight() {
            return this.thumbnailContainerElement.offsetHeight;
        },
        getThumbnailWidth() {
            return this.thumbnailContainerElement.offsetWidth;
        }
    },
}
</script>

<template>
    <div>
        <div v-if="!thumbnail">
            <iframe class="youtube-embed" allowfullscreen loading="lazy" :src="url"></iframe>
        </div>
        <div v-else>
            <div
                class="youtube-embed-thumbnail"
                onclick="this.nextElementSibling.style.display='block'; this.style.display='none'"
            >
                <img
                    :id="thumbnailContainerId" :src="thumbnail" style="cursor:pointer" alt="" @load="isThumbnailLoad = true" />
            </div>
            <div v-if="isThumbnailLoad" style="display:none">
                <iframe
                    loading="lazy"
                    :src="url"
                    :height="getThumbnailHeight"
                    :width="getThumbnailWidth"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>
</template>

<style scoped>
.youtube-embed-thumbnail {
    display: flex;
    align-items: center;
    max-width: 100%;
    max-height: 100%;
    justify-content: center;
}
.youtube-embed-thumbnail img {
    max-width: inherit;
    max-height: inherit;
}
</style>
